<div class="no-items" *ngIf="isVisible">
  <h2>{{ message }}</h2>
  <p>{{ minorMessage }}</p>
  <a (click)="refresh()" *ngIf="buttonTxt">{{ buttonTxt }}</a>
</div>